import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivationComponent } from '@modules/activation/activation.component';
import { ConnexionComponent } from '@modules/connexion/connexion.component';
import { ForgotLoginComponent } from '@modules/connexion/forgot-login/forgot-login.component';
import { TableauDeBordComponent } from '@modules/espace-client/tableau-de-bord/tableau-de-bord.component';
import { PasswordLoggedOutResetComponent } from '@modules/password-logged-out-reset/password-logged-out-reset.component';
import { NextStepIntroductionComponent } from '@modules/souscription/document-medicale/next-step-introduction/next-step-introduction.component';
import { RecapComponent } from '@modules/souscription/document-medicale/recap/recap.component';
import { FinalisationComponent } from '@modules/souscription/finalisation/finalisation.component';
import { ConsentementsComponent } from '@modules/souscription/parcours-medical/consentements/consentements.component';
import { QssComponent } from '@modules/souscription/parcours-medical/questionnaire-de-sante-simplifie/qss.component';
import { SignatureComponent } from '@modules/souscription/signature/signature.component';
import { ChargementComponent } from '@modules/souscription/document-medicale/chargement.component';
import { NotfoundComponent } from '@shared/components/404/notfound.component';
import { DocumentSelectionTypeComponent } from '@modules/souscription/document-medicale/document-selection-type/document-selection-type.component';
import { BasculeMobileComponent } from '@modules/basculeMobile/bascule-mobile.component';
import { DocumentListComponent } from '@modules/souscription/document-medicale/document-list/document-list.component';
import { QsComponent } from '@modules/souscription/parcours-medical/questionnaire-de-sante/qs.component';
import { DifferedDecisionIntroductionComponent } from '@modules/souscription/document-medicale/differed-decision-introduction/differed-decision-introduction.component';
import { AppointmentConsentComponent } from '@modules/souscription/appointment/appointment-consent/appointment-consent.component';
import { AppointmentTypeComponent } from '@modules/souscription/appointment/appointment-type/appointment-type.component';
import { AppointmentDetailsComponent } from '@modules/souscription/document-medicale/arm/appointment-details.component';
import { AppointmentPlannerComponent } from '@modules/souscription/appointment/appointment-planner/appointment-planner.component';
import { EnAttenteComponent } from '@modules/souscription/document-medicale/en-attente/en-attente.component';
import { AppointmentDetailsRdvArmComponent } from '@modules/souscription/appointment/appointment-details/appointment-details.component';
import { OtpConnexionComponent } from '@modules/connexion/otp-connexion/otp-connexion.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'espace-client/tableau-de-bord',
        pathMatch: 'full',
    },
    { path: 'connexion', component: ConnexionComponent },
    { path: 'connexion/otp', component: OtpConnexionComponent },
    {
        path: 'espace-client/tableau-de-bord',
        component: TableauDeBordComponent,
    },
    { path: 'identifiant-oublie', component: ForgotLoginComponent },
    { path: 'activation', component: ActivationComponent },
    {
        path: 'bsc/:primaryProvider/:secondaryProvider/:tokenBasculeMobile',
        component: BasculeMobileComponent,
    },
    { path: 'reinitialisation', component: PasswordLoggedOutResetComponent },
    {
        path: 'souscription/parcours-medical/consentements',
        component: ConsentementsComponent,
    },
    {
        path: 'souscription/parcours-medical/questionnaire-de-sante-simplifie',
        component: QssComponent,
    },
    {
        path: 'souscription/parcours-medical/questionnaire-de-sante',
        component: QsComponent,
    },
    { path: 'souscription/signature', component: SignatureComponent },
    {
        path: 'souscription/document-medicale/chargement',
        component: ChargementComponent,
    },
    {
        path: 'souscription/document-medicale/document-selection-type',
        component: DocumentSelectionTypeComponent,
    },
    { path: 'souscription/finalisation', component: FinalisationComponent },
    {
        path: 'souscription/document-medicale/differed-decision-introduction',
        component: DifferedDecisionIntroductionComponent,
    },
    {
        path: 'souscription/document-medicale/document-list',
        component: DocumentListComponent,
    },
    { path: 'souscription/document-medicale/recap', component: RecapComponent },
    {
        path: 'souscription/document-medicale/next-step-introduction',
        component: NextStepIntroductionComponent,
    },
    {
        path: 'souscription/document-medicale/en-attente',
        component: EnAttenteComponent,
    },
    {
        path: 'souscription/appointment/appointment-consent',
        component: AppointmentConsentComponent,
    },
    {
        path: 'souscription/appointment/appointment-type',
        component: AppointmentTypeComponent,
    },
    {
        path: 'souscription/appointment-details',
        component: AppointmentDetailsComponent,
    },
    {
        path: 'souscription/appointment/appointment-planner',
        component: AppointmentPlannerComponent,
    },
    {
        path: 'souscription/appointment/appointment-details/:centerIdApi',
        component: AppointmentDetailsRdvArmComponent,
    },
    { path: '404', component: NotfoundComponent },
    { path: '**', redirectTo: '/404' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
